import { gql } from '@apollo/client';

export default gql`
  mutation applyDiscountCode($bookingReference: String!, $discountCode: String!) {
    applyDiscountCode(bookingReference: $bookingReference, discountCode: $discountCode) {
      success
      amountOff
      percentageOff
    }
  }
`;
